import i18n from 'modules/core/lib/i18n'

import AdditionalInformationBlock from '../../Blocks/AdditionalInformation'
import { shouldShowBlock } from '../../Blocks/AdditionalInformation/form/schema'
import { CustomizationProps } from '../../withCustomizationFields'
import { PermissionsProps } from '../../withFieldPermissions'
import FormBlock from '../FormBlock'

interface Props extends PermissionsProps, CustomizationProps {
  hasCostCentersFeature: boolean
}

const AdditionalInformation = (props: Props) => {
  const { customizationFields, resourceType, documentType } = props
  const showBlock = shouldShowBlock(customizationFields, resourceType, documentType)

  if (!showBlock) return null

  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.additional_information')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.additional_information_subtitle')}
    >
      <AdditionalInformationBlock {...props} />
    </FormBlock>
  )
}

export default AdditionalInformation
